module.exports = __webpack_public_path__ + "img/Group.e248b523.png";